var map = {
	"./address.svg": "0e25",
	"./agreement.svg": "9467",
	"./cascader.svg": "a393",
	"./checkbox.svg": "8963",
	"./dashboard.svg": "f782",
	"./date-range.svg": "e6df",
	"./date.svg": "235f",
	"./describe.svg": "0bed",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./input.svg": "81d6",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./password1.svg": "0214",
	"./radio.svg": "d8dc",
	"./select.svg": "064a",
	"./slider.svg": "eb1c",
	"./switch.svg": "2384",
	"./table.svg": "47f1",
	"./tel.svg": "2315",
	"./textarea.svg": "128d",
	"./time-range.svg": "861c",
	"./time.svg": "3add",
	"./tree.svg": "93cd",
	"./upload.svg": "9d82",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";